// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 72016 ? "fc22d32c" : chunkId) + "." + {"53348":"6911e2ad2072d121","55880":"79973778f1e25f38","65267":"40a34bb5368d0320","72016":"7418f537f4cd4b02"}[chunkId] + ".js";
};